import { colours } from '@headbox-ui/themes'
import { CSSProperties } from 'react'

const { grey } = colours

export const s = {
  header: {
    height: 'unset',
    padding: '42px 50px 32px 0',
    backgroundColor: '#f5f5f5',
  } as CSSProperties,
  headerBorder: {
    borderBottom: '2px solid #D9D9D9',
  } as CSSProperties,
  layout: { backgroundColor: grey[98] } as CSSProperties,
  headerButton: {
    height: '48px',
    width: '100%',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as CSSProperties,
  archive: {
    root: { padding: '24px 0 12px 0' } as CSSProperties,
    icon: { marginLeft: '70px' } as CSSProperties,
  },
  menuWrapper: {
    height: 'calc(100% - 124px)',
    backgroundColor: '#f5f5f5',
    overflowY: 'auto',
    overflowX: 'hidden',
  } as CSSProperties,
  menu: {
    backgroundColor: '#f5f5f5',
    border: 'unset',
    lineHeight: 'unset',
  } as CSSProperties,
  menuItem: {
    parent: {
      height: 'unset',
      paddingTop: '24px',
      paddingBottom: '24px',
      paddingLeft: 0,
      margin: 0,
    } as CSSProperties,
    selected: { paddingLeft: '18px' } as CSSProperties,
    divider: { backgroundColor: '#D9D9D9' },
    title: {
      common: {
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '22px',
        color: '#AF231C',
      } as CSSProperties,
      archiveColor: '#595959',
    },
    tag: {
      color: '#AF231C',
      style: { marginLeft: '10px', fontSize: '12px', lineHeight: '18px' } as CSSProperties,
    },
    header: { display: 'inline', lineHeight: 'normal' } as CSSProperties,
    base: { display: 'flex', flexDirection: 'column' } as CSSProperties,
    name: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '24px',
      whiteSpace: 'break-spaces',
      color: '#000000D9',
    } as CSSProperties,
    date: { fontWeight: 400, fontSize: '16px', lineHeight: '24px' } as CSSProperties,
    timings: { fontWeight: 400, fontSize: '16px', lineHeight: '24px' } as CSSProperties,
  },
  activeSpinner: {
    padding: '12px 30px 32px 0',
  },
  archiveSpinner: {
    padding: '40px 30px 32px 0',
  },
  noEvents: {
    root: {
      padding: '12px 30px 60px 0',
    },
    text: {
      margin: 'unset',
      whiteSpace: 'normal',
      lineHeight: 'unset',
    } as CSSProperties,
  },
}
